<template>
  <header class="it-header-wrapper it-header-sticky">
    <HeaderTop />
    <div class="it-nav-wrapper">
      <HeaderCenter />
      <HeaderBottom />
    </div>
  </header>
</template>


<script>
import HeaderTop from '@/components/layout/header/HeaderTop';
import HeaderCenter from '@/components/layout/header/HeaderCenter';
import HeaderBottom from '@/components/layout/header/HeaderBottom';

export default {
  name: 'HeaderMain',
  mounted() {
  },
  data() {
    return {
      scrollContainerClass: {
        'progress-bar-container--container': false,
        'scrool-progress-bar': true,
        'sticky-top': true,
      },
      scrollBarClass: {
        'primary-bg': true,
      },
    };
  },
  components: {
    HeaderTop,
    HeaderCenter,
    HeaderBottom,
  },
};
</script>

<style lang="less" scoped>
  .scrool-progress-bar {
    background-color:#ffffff!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/HeaderMain.vue